const HighQualityCareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49.1773 14.7681C49.1563 14.7624 49.1386 14.7485 49.128 14.7295C48.9412 14.3958 47.1295 11.3594 43.0417 11.3594C38.7162 11.3594 36.5906 15.2088 36.5906 18.0115C36.5906 20.8141 36.9891 23.4044 40.4764 26.499C43.6958 29.3557 48.2437 33.5105 48.9236 34.1321C48.9792 34.1829 49.052 34.2095 49.1272 34.2068L49.1506 34.206C49.2116 34.2038 49.2697 34.181 49.3159 34.1409C49.9561 33.5843 54.7873 29.384 58.0727 26.5047C61.5971 23.4159 61.9999 20.8303 61.9999 18.0329C61.9999 15.2354 59.8517 11.3931 55.4802 11.3931C51.4512 11.3931 49.5523 14.2756 49.2795 14.7273C49.2583 14.7625 49.2168 14.7789 49.1773 14.7681Z"
        stroke="#FFA473"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 33.6707V39.1476C2 39.9032 2.61251 40.5157 3.36807 40.5157H6.36551C6.55745 40.5157 6.74723 40.5561 6.92253 40.6342L32.4703 52.0233C32.7634 52.1539 33.093 52.1774 33.4017 52.0896L60.9214 44.2616C61.5095 44.0943 61.9152 43.5571 61.9152 42.9457V40.1929C61.9152 39.4373 61.3027 38.8248 60.5471 38.8248H56.8614C56.7947 38.8248 56.728 38.8297 56.662 38.8394L35.8327 41.9072C35.534 41.9512 35.2292 41.8952 34.9658 41.7479L29.609 38.7531C28.6913 38.24 28.6712 36.9266 29.5728 36.3857L34.6991 33.3103C35.1112 33.0631 35.3633 32.6177 35.3633 32.1371V29.5947C35.3633 28.8391 34.7508 28.2266 33.9953 28.2266H18.5239C18.4061 28.2266 18.2887 28.2418 18.1747 28.2719L6.6814 31.306C6.56744 31.3361 6.45008 31.3513 6.33221 31.3513H3.36807C2.61251 31.3513 2 31.9638 2 32.7194V33.6707Z"
        stroke="#06AEB3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HighQualityCareIcon;
